import React from "react";
import { useForm } from "react-hook-form";
import EditIcon from "../../../assets/img/dashboard/edit-2.svg";
import Input from "../../shared/Input";
import people from "../../../assets/img/checkout/people.svg";
import security from "../../../assets/img/checkout/security-time.svg";
import user from "../../../assets/img/checkout/user.svg";

const RequestForm = ({inforesidencedetail,reserveinfodetail,isReserveSuccess}) => {
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset,setValue
  } = useForm({

  });
  return (
    <div className="RequestForm">
      <form>
        <div className="flex gap-[12px] items-center RequestForm--title">
          <img src={people} />
          <div>
            <p>تعداد مسافران</p>
          </div>
        </div>

        
        <div className="RequestForm--box">
          <p>تعداد</p>
          <div>{reserveinfodetail.guests_count}</div>
        </div>

        <div>
          <div className="flex gap-[12px] items-center RequestForm--title">
            <img src={security} />
            <div>
              <p>تاریخ سفر</p>
            
            </div>
          </div>
        </div>
        <div className="Checkout--grid">
          
           <div className="RequestForm--box">
          <p>از تاریخ</p>
          <div>{reserveinfodetail.reserve_from_date}</div>
        </div>

        <div className="RequestForm--box">
          <p>تا تاریخ</p>
          <div>{reserveinfodetail.reserve_to_date}</div>
        </div>

        </div>
        <div>
          <div className="flex gap-[12px] items-center RequestForm--title">
            <img src={user} />
            <div>
              <p>مشخصات</p>
              <h5>اطلاعات فردی مسافر</h5>
            </div>
          </div>
          <div className="Checkout--grid">
        
           <div className="RequestForm--box">
          <p>نام مسافر</p>
          <div>{reserveinfodetail.reserve_to_date}</div>
        </div>
        <div className="RequestForm--box">
          <p>شماره تماس</p>
          <div>{reserveinfodetail.reserve_to_date}</div>
        </div>
        </div>
        </div>
      </form>
    </div>
  );
};

export default RequestForm;
